import Vue from "vue";
import Vuex from "vuex";
import errors from "@/services/errors";

Vue.use(Vuex);

export default {
  namespaced: true,
  state: {
    dash: null,
    results: null,
    pagination: null,
    statusId: null,
    orderBy: null,
    orderByAsc: null,
    search: null,
    dateFrom: null,
    dateTo: null,
    page: 0,
    pageSize: 30,
    totalResults: null,
    transactionDetails: null,
    listUpdated: false
  },
  mutations: {
    SET_DASH(state, payload) {
      state.dash = payload;
    },
    SET_RESULTS(state, payload) {
      state.results = payload.results;
      state.pagination = payload.pagination;
      state.page = payload.pagination.page;
      state.pageSize = payload.pagination.pageSize;
      state.totalResults = payload.pagination.totalResults;
    },
    SET_STATUS_ID(state, payload) {
      state.statusId = payload;
    },
    SET_ORDER_BY(state, payload) {
      if (payload) {
        state.orderBy = payload.orderBy;
        if (!payload.direction) state.orderByAsc = null;
        else if (payload.direction == "asc") state.orderByAsc = true;
        else state.orderByAsc = false;
      } else {
        state.orderBy = null;
        state.orderByAsc = null;
      }
    },
    SET_SEARCH(state, payload) {
      state.search = payload;
    },
    SET_DATE_FROM(state, payload) {
      state.dateFrom = payload;
    },
    SET_DATE_TO(state, payload) {
      state.dateTo = payload;
    },
    SET_PAGE(state, payload) {
      state.page = payload;
    },
    SET_RESET_PAGE(state, payload) {
      state.page = 0;
      if (state.pagination.page) state.pagination.page = 0;
    },
    SET_RESET(state) {
      state.search = null;
      state.dash = null;
      state.results = null;
      state.pagination = null;
      state.statusId = null;
      state.orderBy = null;
      state.orderByAsc = null;
      state.search = null;
      state.dateFrom = null;
      state.dateTo = null;
      state.page = 0;
      state.pageSize = 30;
      state.totalResults = null;
      state.transactionDetails = null;
      state.listUpdated = false;
    } /*
    SET_PAGE_SIZE(state, payload) {
      state.pageSize = payload;
      state.page = 1; //reset page on page size change
    },*/,
    SET_TRANSACTION_DETAILS(state, payload) {
      state.transactionDetails = payload;
    },
    SET_LIST_UPDATED(state, payload) {
      state.listUpdated = payload;
    }
  },
  actions: {
    async refund({ commit }, payload) {
      try {
        //console.log("userStore: user data stored");
        const res = await Vue.prototype.$axios.post(
          `/transactions/${payload.transactionId}/refund`,
          { refundAmount: payload.refundAmount }
        );
        const x = 10;
        if (res.status != 201) throw errors.handleHTTPError(res);
        else return res.data.transaction;
      } catch (error) {
        throw error;
      }
    },
    //PRE: you can send payload.params to override and set params
    //     at call time. Otherwise it uses the params previously set.
    async load({ commit }, payload) {
      try {
        const params = {
          statusId: this.state.transactions.statusId || "",
          orderBy: this.state.transactions.orderBy || "",
          orderAsc: this.state.transactions.orderByAsc || "",
          page: this.state.transactions.page + 1,
          pageSize: this.state.transactions.pageSize,
          search: this.state.transactions.search || "",
          dateFrom: this.state.transactions.dateFrom || "",
          dateTo: this.state.transactions.dateTo || ""
        };
        if (payload.subscriptionId)
          params.subscriptionId = payload.subscriptionId;
        if (payload.customerId) params.customerId = payload.customerId;
        if (payload.paymentLinkId) params.paymentLinkId = payload.paymentLinkId;
        //console.log("userStore: user data stored");
        const res = await Vue.prototype.$axios.get(`/transactions`, {
          params
        });
        if (res.status != 200) {
          throw errors.handleHTTPError(res);
        }
        if (res.data.results.length > 0) {
          commit("SET_RESULTS", res.data);
        }
      } catch (error) {
        throw error;
      }
    },
    async loadDash({ commit }, payload) {
      try {
        //console.log("userStore: user data stored");
        const res = await Vue.prototype.$axios.get(`/transactions/dash`);
        if (res.status != 200) throw errors.handleHTTPError(res);
        if (res.data) {
          commit("SET_DASH", res.data);
        }
      } catch (error) {
        throw error;
      }
    },
    async loadOne({ commit }, id) {
      try {
        //console.log("userStore: user data stored");
        const res = await Vue.prototype.$axios.get(`/transactions/${id}`);
        if (res.status != 200) throw errors.handleHTTPError(res);
        commit("SET_TRANSACTION_DETAILS", res.data);
      } catch (error) {
        throw error;
      }
    },
    reset({ commit }, id) {
      commit("SET_RESET");
    },
    async loadExport({ commit }, payload) {
      try {
        const params = {
          statusId: this.state.transactions.statusId || "",
          orderBy: this.state.transactions.orderBy || "",
          orderAsc: this.state.transactions.orderByAsc || "",
          page: this.state.transactions.page + 1,
          pageSize: this.state.transactions.pageSize,
          search: this.state.transactions.search || "",
          dateFrom: this.state.transactions.dateFrom || "",
          dateTo: this.state.transactions.dateTo || ""
        };
        if (payload.subscriptionId) {
          params.subscriptionId = payload.subscriptionId;
        }
        if (payload.customerId) {
          params.customerId = payload.customerId;
        }
        if (payload.paymentLinkId) {
          params.paymentLinkId = payload.paymentLinkId;
        }
        params.forExport = true;

        const res = await Vue.prototype.$axios.get(`/transactions`, {
          params
        });
        if (res.status != 200) {
          throw errors.handleHTTPError(res);
        }
        const z = 10;
        return res.data.results;
      } catch (error) {
        throw error;
      }
    },
    async sendInvoice({ commit }, id) {
      try {
        const x = 10;
        //console.log("userStore: user data stored");
        const res = await Vue.prototype.$axios.post(
          `/transactions/${id}/send-invoice`
        );
        if (res.status != 201) {
          throw errors.handleHTTPError(res);
        }
        return res.data.message;
      } catch (error) {
        throw error;
      }
    }
  },
  getters: {
    transactions: state => {
      const transactions = {
        dash: state.dash,
        results: state.results,
        pagination: state.pagination,
        statusId: state.statusId,
        orderBy: state.orderBy,
        search: state.search,
        dateFrom: state.dateFrom,
        dateTo: state.dateTo,
        page: state.page,
        pageSize: state.pageSize,
        totalResults: state.totalResults
      };
      return transactions;
    },
    listUpdated: state => {
      return state.listUpdated;
    }
  }
};
